module.exports = __webpack_public_path__ + "static/media/06._Hello_Panda_New_2019-01.c69c664e.png";